export const APP_CONFIG = {
  // isMobile: true,
  enableRxDebug: false
};
